import env from '../../utils/env';
import { AB_TEST, type AbTestAction } from '../actions/abTestActions';

export const GWP_SEGMENTS = {
  DEFAULT: 'DEFAULT',
  VARIANT_A: 'VARIANT_A',
  VARIANT_B: 'VARIANT_B',
};

export type GwpSegment = 'DEFAULT' | 'VARIANT_A' | 'VARIANT_B';

export type AbTestState = {
  gwpSegment: GwpSegment | null;
  loading: boolean | null;
  error: string | null;
};

export const abTestInitialState = {
  gwpSegment: GWP_SEGMENTS.DEFAULT,
  loading: false,
  error: null,
};

const mapVariantToGwpSegments = (variantId) => {
  switch (variantId) {
    case -1:
      return GWP_SEGMENTS.DEFAULT;
    case parseInt(env.abTestGwpVariantAId, 10):
      return GWP_SEGMENTS.VARIANT_A;
    case parseInt(env.abTestGwpVariantBId, 10):
      return GWP_SEGMENTS.VARIANT_B;
    default:
      return GWP_SEGMENTS.DEFAULT;
  }
};

export function abTestReducer(state = abTestInitialState, action: AbTestAction): AbTestState {
  switch (action.type) {
    case AB_TEST.GWP_AB_TEST_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null,
      };
    }
    case AB_TEST.GWP_AB_TEST_SUCCESS: {
      const gwpSegment = mapVariantToGwpSegments(action.payload.variantId);
      return {
        ...state,
        gwpSegment,
        loading: false,
      };
    }
    case AB_TEST.GWP_AB_TEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    }
    default: {
      return state;
    }
  }
}

export default abTestReducer;
